import React from 'react'
import styled from 'styled-components'
import { Tooltip, PlacesType } from 'react-tooltip'

interface IGameTooltipProps {
	id: string
	children: React.ReactNode
	place?: PlacesType
	offset?: number
	arrowSize?: number
	backgroundColor?: string
	arrowColor?: string
}

// react-tooltip v6 injects its stylesheet after ours with single-class selectors and sets font-size: 90%
// of the (very large) inherited size, so every override doubles the class (&&) to win on specificity.
// Values were tuned against the v4 tooltip at 400% zoom.
const StyledTooltip = styled(Tooltip)<{ $backgroundColor: string; $arrowColor: string }>`
	&& {
		background: ${({ $backgroundColor }) => $backgroundColor};
		z-index: 1000;
		font-size: 13px;
		line-height: 13px;
	}

	&& .react-tooltip-content-wrapper {
		padding: 9px 22px;
	}

	/* v4 drew a full opaque diamond on top of the box; v6 hides half the arrow behind the content */
	&& .react-tooltip-arrow {
		background: ${({ $arrowColor }) => $arrowColor};
		z-index: 2;
	}
`

const GameTooltip: React.FC<IGameTooltipProps> = ({
	id,
	children,
	place = 'top',
	offset = 13,
	arrowSize = 12,
	backgroundColor = '#152d39',
	arrowColor = '#222',
}) => (
	<StyledTooltip
		id={id}
		variant='dark'
		place={place}
		positionStrategy='fixed'
		arrowSize={arrowSize}
		offset={offset}
		$backgroundColor={backgroundColor}
		$arrowColor={arrowColor}
	>
		{children}
	</StyledTooltip>
)

export default GameTooltip
